import { FormattedMessage } from '@alltrails/shared/react-intl';
import Typography from '@alltrails/shared/denali/components/Typography';
import FacebookIcon from '@alltrails/shared/components/socialIcons/FacebookIcon';
import LinkedInIcon from '@alltrails/shared/components/socialIcons/LinkedInIcon';
import InstagramIcon from '@alltrails/shared/components/socialIcons/InstagramIcon';
import TikTokIcon from '@alltrails/shared/components/socialIcons/TikTokIcon';
import TwitterIcon from '@alltrails/shared/components/socialIcons/TwitterIcon';
import * as styles from './styles/styles.module.scss';

interface Props {
  noFollowSocials?: boolean;
}

const ConnectWithUs = ({ noFollowSocials = true }: Props) => (
  <>
    <div className={styles.title} data-testid="connect-with-us">
      <Typography component="h2" variant="text300bold" color="inverse">
        <FormattedMessage defaultMessage="Connect with us" />
      </Typography>
    </div>
    <div className={styles.socialIcons}>
      <InstagramIcon className={styles.hoverClass} noFollowSocials={noFollowSocials} />
      <TikTokIcon className={styles.hoverClass} noFollowSocials={noFollowSocials} />
      <FacebookIcon className={styles.hoverClass} noFollowSocials={noFollowSocials} />
      <TwitterIcon className={styles.hoverClass} noFollowSocials={noFollowSocials} />
      <LinkedInIcon className={styles.hoverClass} noFollowSocials={noFollowSocials} />
    </div>
  </>
);

export default ConnectWithUs;
